module.exports = __webpack_public_path__ + "img/fapiao.8749f7b3.png";